import { callProcedure } from 'clickNgo/helpers/api'
import type { IProcedureResponse } from 'clickNgo/models/api'

import { PLAN_REVIEW_COMMENTS_SECTION } from '../config/justification'
import { mapPlanReviewCommentsFromApi } from '../lib/mapPlanReviewCommentsFromApi'
import type { TPlanReviewOffering } from '../model/types'

import type { IPlanReviewCommentApi } from './types'

interface IFetchPlanReviewJustificationsParams {
  partnerId: string
  fYear: number
  programType: TPlanReviewOffering
  isGlobal: boolean
}

export const fetchPlanReviewJustifications = async ({
  partnerId,
  fYear,
  programType,
  isGlobal,
}: IFetchPlanReviewJustificationsParams) => {
  const response = await callProcedure<IProcedureResponse<IPlanReviewCommentApi[]>>({
    url: '/webservice/621/sp/v4/spJBPComments/call',
    method: 'POST',
    data: {
      'p.EntryID': 0,
      'p.PartnerId': partnerId,
      'p.Params': '',
      'p.Section': PLAN_REVIEW_COMMENTS_SECTION,
    },
  })

  if ('error' in response) {
    throw response.error
  }

  return mapPlanReviewCommentsFromApi(response.data?.Data ?? [], {
    partnerId,
    fYear,
    programType,
    isGlobal,
  })
}
